<!-- Translated: yes -->
<template>
  <Modal @close="goOn" :wide="false" :z-index="params.zIndex || null" width="450px" :show-close="false">
    <h1>{{ $t('skirental.timeout.hm') }}</h1>
    <p v-if="$store.state.isOnSite">{{ $t('skirental.timeout.question') }}</p>
    <p v-if="!$store.state.isOnSite">Din bokning är reserverad. Eftersom du har lämnat din bokning kommer det du har reserverat att släppas fritt för andra att boka snart.</p>

    <div v-if="params.inactive && params.inactive()">
      <p v-if="$store.state.isOnSite">{{ $t('skirental.timeout.text') }}</p>
      <p v-if="!$store.state.isOnSite">Tid kvar:</p>

      <br>

      <h2 v-if="params.inactive()">{{ timeLeft() }}</h2>

      <br>
    </div>

    <br>

    <button @click="goOn">{{ $t('skirental.timeout.cta-continue') }}</button>
    <button class="white" @click="cancel" v-if="$store.state.isOnSite">{{ $t('skirental.timeout.cta-cancel') }}</button>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import CompletedBookings from '@/components/parts/CompletedBookings';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CompletedBookings,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
    ]),
    goTo(path) {
      this.closeModal();
      this.$router.push({ path });
    },
    goOn() {
      if (this.params.continue) {
        this.params.continue();
      }
    },
    cancel() {
      if (this.params.cancel) {
        this.params.cancel();
      }
    },
    timeLeft() {
      if (this.params.seconds && this.params.seconds()) {
        const seconds = this.params.seconds();

        let m = 0;
        let s = 0;

        if (seconds >= 60) {
          m = Math.floor(seconds / 60);
          s = seconds - (m * 60);
        } else {
          m = 0;
          s = seconds;
        }

        if (m < 10) {
          if (m < 0) {
            m = 0;
          } else {
            m = `0${m}`;
          }
        }
        if (s < 0) {
          s = 0;
        }
        if (s < 10) {
          s = `0${s}`;
        }

        return `${m}:${s}`;
      }
      return 'Avbruten';
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.high-five
  margin-bottom 15px

h1
  font-size: 30px;
  font-weight: 900;
  margin-bottom 5px

h2
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()

.modalo
  text-align center
</style>



// WEBPACK FOOTER //
// TimeoutModal.vue?b83ef71a